module.exports = __webpack_public_path__ + "static/media/three_coaches_portrait.07fc158e.svg";


//////////////////
// WEBPACK FOOTER
// ./packages/smart-home-support/pages/profile/resources/three_coaches_portrait.svg
// module id = 3455
// module chunks = 0